import {
  OBJECTIVE_AMOUNT,
  OBJECTIVE_PERCENTAGE,
  PERFORMANCE_GOAL_TYPE_AUDIO_COMPLETION_RATE,
  PERFORMANCE_GOAL_TYPE_CLICK_CVR,
  PERFORMANCE_GOAL_TYPE_CPA,
  PERFORMANCE_GOAL_TYPE_CPC,
  PERFORMANCE_GOAL_TYPE_CPIAVC,
  PERFORMANCE_GOAL_TYPE_CPM,
  PERFORMANCE_GOAL_TYPE_CTR,
  PERFORMANCE_GOAL_TYPE_IMPRESSION_CVR,
  PERFORMANCE_GOAL_TYPE_VCPM,
  PERFORMANCE_GOAL_TYPE_VIDEO_COMPLETION_RATE,
  PERFORMANCE_GOAL_TYPE_VIEWABILITY,
  PERFORMANCE_GOAL_TYPE_VTR
} from './CampaignForms/CampaignDv360Create/CampaignDv360CreateForm/fields'

export function getBiddingStrategyPerformanceGoalType(campaignPerformanceGoalType) {
  return campaignPerformanceGoalType === PERFORMANCE_GOAL_TYPE_CPA
    ? 'BIDDING_STRATEGY_PERFORMANCE_GOAL_TYPE_CPA'
    : 'BIDDING_STRATEGY_PERFORMANCE_GOAL_TYPE_CPC'
}

export const getObjectiveAmountField = campaignPerformanceGoalType => {
  switch (campaignPerformanceGoalType) {
    case PERFORMANCE_GOAL_TYPE_CTR:
    case PERFORMANCE_GOAL_TYPE_VIEWABILITY:
    case PERFORMANCE_GOAL_TYPE_CLICK_CVR:
    case PERFORMANCE_GOAL_TYPE_IMPRESSION_CVR:
    case PERFORMANCE_GOAL_TYPE_VTR:
      return OBJECTIVE_PERCENTAGE

    case PERFORMANCE_GOAL_TYPE_CPM:
    case PERFORMANCE_GOAL_TYPE_CPA:
    case PERFORMANCE_GOAL_TYPE_CPC:
    case PERFORMANCE_GOAL_TYPE_CPIAVC:
    case PERFORMANCE_GOAL_TYPE_VCPM:
    case PERFORMANCE_GOAL_TYPE_AUDIO_COMPLETION_RATE:
    case PERFORMANCE_GOAL_TYPE_VIDEO_COMPLETION_RATE:
    default:
      return OBJECTIVE_AMOUNT
  }
}
